import Swiper, { Pagination,EffectFade, Autoplay } from 'swiper';
import "swiper/scss";
import "swiper/scss/effect-fade";

const heroSlider = () => {
    document.addEventListener('DOMContentLoaded', () => {
        
        document.querySelectorAll('[data-hero-slider-arrows-link]').forEach((heroSliderLink) => {
            heroSliderLink.addEventListener('click', (event) => {
                event.preventDefault();
                const scrollToElem = document.querySelector('[data-hero-slider-scroll-to]');
                if(!scrollToElem) return;
                scrollToElem.scrollIntoView({behavior: 'smooth'});
            });
        });

        const swiper = new Swiper('.hero-slider__slider', {
            modules: [Pagination,EffectFade,Autoplay],
            speed: 1000,
            effect: 'fade',
            allowTouchMove: false,
            spaceBetween: 15,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false
            },
            loop: true,
            pagination: {
                el: '.hero-slider .swiper-pagination',
                clickable: true,
                renderBullet: (index, className) => {
                    return '<path class="' + className + '" id="Pfad_50" data-name="Pfad 50" d="M29.847,0,0,33.086H14.208L44.056,0Z" transform="translate(' + (index * 20) + ' 0)"/>';
                },
            }
        });
        let prevIndex = 0;
        swiper.on('slideChange', () => {
            const heroSlider = document.querySelector('[data-hero-slider]');
            if(!heroSlider) return;
            const prevText = heroSlider.querySelector('[data-slide-count="' + prevIndex + '"]');
            const currentText = heroSlider.querySelector('[data-slide-count="' + swiper.realIndex + '"]');
            prevIndex = swiper.realIndex;
            const textContainer = document.querySelector('[data-hero-slider-text]');
            if(!prevText || !currentText || !textContainer) return;
            textContainer.classList.add('hero-slider__text-container--enable-animation');
            prevText.classList.remove('hero-slider__text--active');
            currentText.classList.add('hero-slider__text--active');
        });
    });
}

export { heroSlider }
